<div *ngIf="execution">
    <div class="mb-3">
        <h6 class="mb-1">{{execution?.task_checklist_label}}</h6>
        <span class="badge me-1" [ngClass]="execution?.status=='completed' ? 'bg-primary' : 'bg-warning'">
            {{ execution?.status=='completed' ? 'Completada' : 'En progreso' }}
        </span>
        <span class="badge bg-dark">{{execution?.completion_percentage}}% completado</span>
        <div class="small text-muted mt-1">
            <i class="fa-solid fa-person-military-pointing me-1"></i>{{execution?.guard_name}}
            <br>
            <i class="fa-regular fa-clock me-1"></i>{{execution?.started_at}}
            <span *ngIf="execution?.finished_at"> - {{execution?.finished_at}}</span>
        </div>
    </div>
    <hr>
    <div class="card mb-2" *ngFor="let item of execution?.items">
        <div class="card-body py-2">
            <div class="d-flex justify-content-between align-items-start">
                <div>
                    <span class="badge me-1" [ngClass]="item?.checked ? 'bg-success' : 'bg-secondary'">
                        {{ item?.checked ? 'Sí' : 'No' }}
                    </span>
                    <span>{{item?.label}}</span>
                </div>
                <span class="badge bg-warning" *ngIf="item?.evidence_required && !item?.evidence?.length">
                    <i class="fa-solid fa-circle-exclamation"></i> Sin evidencia
                </span>
            </div>
            <div class="small text-muted mt-1" *ngIf="item?.observation">
                <b>Observación:</b> {{item?.observation}}
            </div>
            <div class="mt-2 d-flex flex-wrap gap-2" *ngIf="item?.evidence?.length">
                <a *ngFor="let ev of item?.evidence" [href]="ev?.url" target="_blank" rel="noopener">
                    <img [src]="ev?.url" [alt]="ev?.original_filename"
                        style="max-height:80px; max-width:120px; object-fit:cover; border-radius:4px; border:1px solid #e3e6f0;">
                </a>
            </div>
        </div>
    </div>
    <div class="text-muted small" *ngIf="!execution?.items?.length">Sin tareas registradas en esta ejecución.</div>
</div>
<div *ngIf="!execution" class="text-center text-muted py-4">
    <i class="fa-solid fa-spinner fa-spin"></i> Cargando...
</div>
